import icon from "@material-ui/icons/ShopTwo"

export default { icon } ;